export const MCP_AUTO_PUBLISH_ENABLED_KEY = "xhandle.mcp.autoPublish.enabled";
export const MCP_AUTO_PUBLISH_SCOPE_KEY = "xhandle.mcp.autoPublish.scope";
export const MCP_SNAPSHOT_PUBLISHED_EVENT = "xhandle:mcp-snapshot-published";
export const MCP_SNAPSHOT_PUBLISH_ERROR_EVENT = "xhandle:mcp-snapshot-publish-error";

export function getMcpAutoPublishEnabled(storage = localStorage) {
  try {
    return storage.getItem(MCP_AUTO_PUBLISH_ENABLED_KEY) !== "false";
  } catch {
    return true;
  }
}

export function setMcpAutoPublishEnabled(enabled, storage = localStorage) {
  try {
    storage.setItem(MCP_AUTO_PUBLISH_ENABLED_KEY, enabled ? "true" : "false");
  } catch {}
  return Boolean(enabled);
}

export function normalizeMcpAutoPublishScope(scope) {
  return scope === "project" ? "project" : "workspace";
}

export function getMcpAutoPublishScope(storage = localStorage) {
  try {
    return normalizeMcpAutoPublishScope(storage.getItem(MCP_AUTO_PUBLISH_SCOPE_KEY));
  } catch {
    return "workspace";
  }
}

export function setMcpAutoPublishScope(scope, storage = localStorage) {
  const normalized = normalizeMcpAutoPublishScope(scope);
  try {
    storage.setItem(MCP_AUTO_PUBLISH_SCOPE_KEY, normalized);
  } catch {}
  return normalized;
}
